import Vue from 'vue'
import aBase from './aBase'
import aOrder from './aOrder'
import aSquare from './aSquare'
import aGrouped from './aGrouped'

Vue.component('a-base', aBase)
Vue.component('a-order', aOrder)
Vue.component('a-square', aSquare)
Vue.component('a-grouped', aGrouped)
